"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
var react_1 = require("react");
var core_1 = require("@unform/core");
var styles_1 = require("./styles");
var DateInput = function (_a) {
    var name = _a.name, handleInputError = _a.handleInputError, messageErrorOnBlur = _a.messageErrorOnBlur, isDisabled = _a.isDisabled, rest = __rest(_a, ["name", "handleInputError", "messageErrorOnBlur", "isDisabled"]);
    var inputRef = react_1.useRef(null);
    var _b = core_1.useField(name), fieldName = _b.fieldName, defaultValue = _b.defaultValue, registerField = _b.registerField, clearError = _b.clearError;
    react_1.useEffect(function () {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
            setValue: function (ref, value) {
                // console.log(value);
                ref.value = value;
                clearError();
            },
        });
    }, [fieldName, registerField, clearError]);
    var handleBlur = react_1.useCallback(function (event) {
        if (!event.target.value) {
            if (!!handleInputError && !!messageErrorOnBlur) {
                handleInputError({
                    inputName: name,
                    message: messageErrorOnBlur,
                });
            }
        }
        else
            return;
    }, [handleInputError, messageErrorOnBlur, name]);
    return (jsx_runtime_1.jsx(styles_1.Container, { children: jsx_runtime_1.jsx("div", __assign({ className: "input-wrapper" }, { children: jsx_runtime_1.jsx("input", __assign({ name: name, type: "date", ref: inputRef, defaultValue: defaultValue, onBlur: handleBlur, disabled: isDisabled, onFocus: function () {
                    clearError();
                } }, rest), void 0) }), void 0) }, void 0));
};
exports.default = DateInput;
//# sourceMappingURL=index.js.map